import moment from 'moment'

import { mapObject } from 'lib/object/objectUtils'
import type { GetTripDocumentsResponse } from 'tripPlanner/api/documents/types'
import type { TripDocumentsResult } from 'tripPlanner/hooks/api/documents'
import type { TripDocument } from 'tripPlanner/types/documents'

type APIDocument = GetTripDocumentsResponse['result']['unAttachedFiles'][number]

export function mapTripDocument(document: APIDocument): TripDocument {
  return {
    filename: document.key.replace(/^.*\//, ''),
    size: document.size,
    lastModified: moment(document.lastModified),
    key: document.key,
  }
}

export function mapTripDocuments(
  documents: GetTripDocumentsResponse['result'],
): TripDocumentsResult {
  return {
    attachedFiles: mapObject(documents.attachedFiles, (files) =>
      files.map(mapTripDocument),
    ),
    unAttachedFiles: documents.unAttachedFiles.map(mapTripDocument),
  }
}
